<!-- Branch Management -->
<template>
  <div class="bm-list-page">
    <div class="main-table-section">
      <!-- 왼쪽: 본부별/연도별 달성률 표 -->
      <ag-grid-vue
        class="ag-bm-balham"
        :style="{ width: '100%', height: gridHeight1 + 'rem' }"
        :rowData="mainTableData"
        :columnDefs="mainTableDefs"
        :theme="theme"
        :suppressHorizontalScroll="false"
        :gridOptions="mainTableGridOptions"
        :rowHeight="rowHeight"
        @grid-ready="onGridReady"
      />
    </div>
    <div class="side-table-section">
      <!-- <div class="side-button-container">
        <button @click="toggleNewGridView" class="view-toggle-button">
          {{ showNewGrid ? "달성률 보기" : "경영지도" }}
        </button>
      </div> -->
      <!-- 오른쪽: 연간 최고 달성률, 본부 최고수량 대비 달성률 -->
      <div v-if="!useNewGrid" class="side-table-group">
        <div class="side-table">
          <ag-grid-vue
            class="ag-bm-balham"
            :style="{ width: '100%', height: gridHeight2 + 'rem' }"
            :rowData="yearBestData"
            :columnDefs="yearBestDefs"
            :theme="theme"
            :gridOptions="rightGridOptions"
            @grid-ready="onGridReady"
          />
        </div>
        <div class="side-table">
          <ag-grid-vue
            class="ag-bm-balham"
            :style="{ width: '100%', height: gridHeight2 + 'rem' }"
            :rowData="branchBestData"
            :columnDefs="branchBestDefs"
            :theme="theme"
            :gridOptions="rightGridOptions"
            @grid-ready="onGridReady"
          />
        </div>
      </div>
      <div v-else class="side-table">
        <ag-grid-vue
          class="ag-bm-balham"
          :style="{ width: '100%', height: gridHeight3 + 'rem' }"
          :rowData="manageGuidanceData"
          :columnDefs="manageGuidanceDefs"
          :theme="theme"
          :gridOptions="manageGuidanceGridOptions"
          @grid-ready="onGridReady"
          @cell-clicked="onCellClicked"
        />
        <ag-grid-vue
          class="ag-bm-balham"
          :style="{ width: '100%', height: gridHeight4 + 'rem' }"
          :rowData="manageGuiDetailData"
          :columnDefs="manageGuiDetailDefs"
          :theme="theme"
          :gridOptions="managerGuiDetailGridOptions"
          @grid-ready="onGridReady"
        />
      </div>
    </div>
    <div v-if="showDownPopup" class="popup">
      <div class="popup-header">
        <h3>하락 점포 알림</h3>
        <button @click="showDownPopup = false">X</button>
      </div>
      <p>
        전월 대비 20% 또는 전년 대비 30% 이상 하락한 점포가 있습니다.
      </p>
      <div class="table">
        <ag-grid-vue
          class="ag-bm-balham"
          :style="{ width: '100%', height: '30rem' }"
          :rowData="downShops"
          :columnDefs="downShopDefs"
          :grid-options="popupGridOptions"
          :theme="theme"
          @sort-changed="onSortChanged"
        />
      </div>
      <!-- <table>
        <tbody>
          <tr>
            <th></th>
            <th>점포명</th>
            <th>전월 판매량</th>
            <th>전년 판매량</th>
            <th>이번달 예상</th>
            <th @click="sortBy('DIFF_RATE_MONTH')">
              전월 증감률
              <span v-if="sortKey === 'DIFF_RATE_MONTH'">
                {{ sortOrder === 1 ? '▲' : '▼' }}
              </span>
            </th>
            <th @click="sortBy('DIFF_RATE_YEAR')">
              전년 증감률
              <span v-if="sortKey === 'DIFF_RATE_YEAR'">
                {{ sortOrder === 1 ? '▲' : '▼' }}
              </span>
            </th>
          </tr>
          <tr v-for="(shop, rows) in sortedShops" :key="shop.SHOP_CD">
            <td>{{ rows + 1 }}</td>
            <td>{{ shop.SHOP_NM }}</td>
            <td>{{ shop.PREV_QTY || 0 }}</td>
            <td>{{ shop.PREV_YEAR_QTY || 0 }}</td>
            <td>{{ Math.round(shop.NEXT_QTY) || 0 }}</td>
            <td :style="{ color: shop.DIFF_RATE_MONTH <= -20 ? 'blue' : 'black',
                backgroundColor: shop.DIFF_RATE_MONTH <= -20 ? '#fef05c' : 'white' 
               }"
            >
              {{ shop.DIFF_RATE_MONTH || 0 }}%
            </td>
            <td :style="{ color: shop.DIFF_RATE_YEAR <= -30 ? 'blue' : 'black', 
                backgroundColor: shop.DIFF_RATE_YEAR <= -30 ? '#f66c6c' : 'transparent'
              }"
            >
              {{ shop.DIFF_RATE_YEAR || 0 }}%
            </td>
          </tr>
        </tbody>
      </table> -->
      <button @click="showDownPopup = false">닫기</button>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";

export default {
  name: "BmListPage",
  components: { AgGridVue },
  props: {
    useNewGrid: Boolean,
  },
  data() {
    const now = new Date();
    const thisYear = now.getFullYear();
    // 기준: 올해, 올해-1, 올해-2
    const year1 = thisYear;
    const year2 = thisYear - 1;
    const year3 = thisYear - 2;

    return {
      downShops: [],
      sortKey: null, // 현재 정렬 기준
      sortOrder: 1, // 1: 오름차순, -1: 내림차순
      showDownPopup: false,
      downShopDefs: [
        {
          headerName: "",
          field: "no",
          valueGetter: "node.rowIndex + 1",
          cellStyle: { textAlign: "center" },
          flex: 0.3,
        },
        {
          headerName: "본부",
          field: "BRANCH_NM",
          cellStyle: { textAlign: "center" },
          flex: 0.5,
        },
        {
          headerName: "점포명",
          field: "SHOP_NM",
          cellStyle: { textAlign: "center" },
          flex: 1,
        },
        {
          headerName: "전월 판매량",
          field: "PREV_QTY",
          cellStyle: { textAlign: "center" },
          flex: 1,
        },
        {
          headerName: "전년 판매량",
          field: "PREV_YEAR_QTY",
          cellStyle: { textAlign: "center" },
          flex: 1,
          valueFormatter: (p) => p.value || 0,
        },
        {
          headerName: "이번달 예상",
          field: "NEXT_QTY",
          flex: 1,
          cellStyle: { textAlign: "center" },
          valueFormatter: (p) => Math.round(p.value) || 0,
        },
        {
          headerName: "전월 증감률",
          field: "DIFF_RATE_MONTH",
          flex: 1,
          valueFormatter: (p) => (p.value || 0) + "%",
          cellStyle: (params) => ({
            textAlign: "center",
            color: params.value <= -20 ? "red" : "black",
            backgroundColor: params.value <= -20 ? "#fef05c" : "white",
          }),
        },
        {
          headerName: "전년 증감률",
          field: "DIFF_RATE_YEAR",
          flex: 1,
          valueFormatter: (p) => (p.value || 0) + "%",
          cellStyle: (params) => ({
            textAlign: "center",
            color: params.value <= -30 ? "blue" : "black",
            backgroundColor: params.value <= -30 ? "#fab251" : "transparent",
          }),
        },
      ],

      popupGridOptions: {
        headerHeight: 30,
        rowHeight: 30,
        quickFilterText: "",
        suppressHorizontalScroll: false,
        defaultColDef: {
          sortable: true,
          comparator: (valueA, valueB) => {
            const a = valueA == null || valueA === "" ? 0 : valueA;
            const b = valueB == null || valueB === "" ? 0 : valueB;

            const isANumber = !isNaN(parseFloat(a)) && isFinite(a);
            const isBNumber = !isNaN(parseFloat(b)) && isFinite(b);

            if (isANumber && isBNumber) {
              return a - b;
            }
            if (!isANumber && !isBNumber) {
              return String(a).localeCompare(String(b));
            }
            return isANumber ? -1 : 1;
          },
          resizable: false,
          fontWeight:"bold",
          headerStyle: {
            color: "black",
            textAlign: "center",
            fontSize:"1rem",
            alignContent: "center",
          },
        },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      userInfo: null,
      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        // headerHeight: "20px",
        borderColor: "#c0c0c0",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: "100%",
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      rowHeight: window.innerWidth > 1024 ? 23 : 18, // 행 높이

      gridHeight1: window.innerWidth > 1024 ? 50 : 43.75, // 그리드2 높이

      gridHeight2: window.innerWidth > 1024 ? 25 : 21.875, // 그리드2 높이

      gridHeight3: window.innerWidth > 1024 ? 19 : 17.75, // 그리드3 높이

      gridHeight4: window.innerWidth > 1024 ? 31 : 26, // 그리드4 높이

      // showNewGrid: false, // 신규 그리드 표시 여부

      mainTableData: [],
      mainTableDefs: [
        {
          headerName: "",
          field: "branchNm",

          width: 48,
          minWidth: 48,
          flex: 0.6,
          // spanRows: true, // 사용못함
          rowSpan: this.calculateRowSpan,
          valueFormatter: (params) => {
            const [region, name] = params.value.split("  ");
            return `${region}\n${name}`;
          },
          colSpan: (params) => {
            // 조건에 따라 열 병합
            if (
              params.data &&
              params.data.branchCd.includes("00") &&
              params.data.years === String(new Date().getFullYear())
            ) {
              return 2; // 두 개의 열을 병합
            }
            return 1; // 기본적으로 한 개의 열
          },
          cellStyle: this.getMainGridStyle,
        },
        {
          headerName: "",
          field: "years",

          width: 50,
          minWidth: 50,
          flex: 0.8,
          cellStyle: this.getMainGridStyle,
        },
        ...[...Array(12)].map((_, i) => {
          const m = i + 1;
          return {
            headerName: `${m}월`,
            field: `m${String(m).padStart(2, "0")}`,
            flex: 1,
            cellStyle: this.getMainCellStyle,
          };
        }),
        {
          headerName: "합계",
          field: "mSum",
          flex: 1,
          cellStyle: this.getMainCellStyle,
        },
      ],
      mainTableGridOptions: {
        enableCellSpan: true,
        defaultColDef: {
          resizable: true,
          sortable: true,
          headerStyle: {
            color: "black",
            textAlign: "center",
            alignContent: "center",
          },
        },
        rowHeight: 18,
        headerHeight: 25,
        rowSelection: { mode: "singleRow", checkboxes: false },
        animateRows: true,
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        suppressRowTransform: true, // 행 병합 시 필수 (렌더링 최적화 및 오류 방지)
      },
      yearBestData: [],
      yearBestDefs: [
        {
          headerName: "연간 최고 달성률",
          headerStyle: {
            color: "black",
            backgroundColor: "#ffe0c0",
            textAlign: "center",
          },
          children: [
            {
              headerName: "순위",
              field: "rank",
              cellStyle: { "text-align": "center" },
              width: 32,
              flex: 0.6,
            },
            {
              headerName: "본부",
              field: "branchNm",
              cellStyle: { "text-align": "center" },
              width: 32,
              flex: 0.7,
            },
            {
              headerName: "FC명",
              field: "managerNm",
              cellStyle: { "text-align": "center" },
              width: 44,
              flex: 1.3,
            },
          ],
        },

        {
          headerName: `${year1}년`,
          headerStyle: { color: "black", backgroundColor: "#ffe0c0" },
          children: [
            {
              headerName: "달성",
              field: "yearRate",
              width: 32,
              flex: 1,
              cellStyle: { background: "#ffffb5" },
            },
            {
              headerName: "차이",
              field: "diff1",
              width: 32,
              flex: 1,
              cellStyle: (params) => {
                let style = {};
                style.background = "#ffffb5";
                if (params.value < 0) {
                  style.color = "blue"; // 음수일 때 파란색
                }
                return style;
              },
            },
          ],
        },
        {
          headerName: `${year2}년`,
          headerStyle: { color: "black", backgroundColor: "#ffe0c0" },
          children: [
            {
              headerName: "달성",
              field: "lastYear1",
              width: 32,
              flex: 1,
              cellStyle: (params) => {
                return {
                  background: "#efeeff",
                  color: params.data.diff2 === 0 ? "red" : "black", // 차이 컬럼이 0이면 빨간 글자
                };
              },
            },
            {
              headerName: "차이",
              field: "diff2",
              width: 32,
              flex: 1,
              cellStyle: { background: "#efeeff" },
            },
          ],
        },
        {
          headerName: `${year3}년`,
          headerStyle: { color: "black", backgroundColor: "#ffe0c0" },
          children: [
            {
              headerName: "달성",
              field: "lastYear2",
              width: 32,
              flex: 1,
              cellStyle: (params) => {
                return {
                  background: "#d5ffca",
                  color: params.data.diff3 === 0 ? "red" : "black", // 차이 컬럼이 0이면 빨간 글자
                };
              },
            },
            {
              headerName: "차이",
              field: "diff3",
              width: 32,
              flex: 1,
              cellStyle: { background: "#d5ffca" },
            },
          ],
        },
        {
          headerName: "차이평균",
          field: "avgDiff",
          wrapHeaderText: true,
          width: 32,
          flex: 1,
        },
      ],
      rightGridOptions: {
        defaultColDef: {
          resizable: true,
          sortable: true,
          headerStyle: {
            backgroundColor: "#ffe0c0",
            color: "black",
            textAlign: "center",
            alignContent: "center",
          },
        },
        headerHeight: 35,
        rowHeight: 27.5,
        rowSelection: { mode: "singleRow", checkboxes: false },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },

      branchBestData: [],
      branchBestDefs: [
        {
          headerName: "본부 최고수량 대비 월간 달성률",
          headerStyle: { color: "black", backgroundColor: "#ffe0c0" },
          children: [
            {
              headerName: "순위",
              field: "rank",
              width: 55,
              flex: 1,
              cellStyle: { "text-align": "center" },
            },
            {
              headerName: "FC",
              field: "branchNm",
              width: 60,
              flex: 1,
              cellStyle: { "text-align": "center" },
            },
            {
              headerName: "FC명",
              field: "branchOwn",
              width: 70,
              flex: 1,
              cellStyle: { "text-align": "center" },
            },
            {
              headerName: "최고대비\n달성률",
              field: "maxPercent",
              wrapHeaderText: true,
              width: 80,
              flex: 1,
              headerStyle: { "text-align": "center" },
            },
            { headerName: "차이", field: "diff", width: 65, flex: 1 },
          ],
        },
      ],
      manageGuidanceData: [], // 신규 그리드를 위한 데이터
      manageGuidanceDefs: [
        // 신규 그리드를 위한 컬럼 정의
        {
          headerName: "",
          field: "BRANCH_CD",
          hide: true, // 숨김 컬럼
        },
        {
          headerName: "순서",
          valueGetter: "node.rowIndex",
          width: 34,
          cellStyle: (params) => {
            if (params.node.rowIndex === 0) {
              return { display: "none" }; // 특정 행에서만 숨김
            }
            return { textAlign: "center" };
          },
        },
        {
          headerName: "본부",
          field: "branchNm",
          flex: 1.3,
          cellStyle: { textAlign: "center" },
          colSpan: (params) => {
            // 조건에 따라 열 병합
            if (params.data.branchNm === "합계") {
              return 2; // 두 개의 열을 병합
            }
            return 1; // 기본적으로 한 개의 열
          },
        },
        {
          headerName: "FC",
          field: "branchOwn",
          flex: 1.3,
          cellStyle: (params) => {
            if (params.data.branchNm === "합계") {
              return { display: "none" }; // 특정 행에서만 숨김
            }
            return { textAlign: "center" };
          },
        },
        {
          headerName: "대상",
          field: "target",
          flex: 1,
          cellStyle: { textAlign: "right" },
        },
        {
          headerName: "개선",
          field: "improvement",
          flex: 1,
          cellStyle: { textAlign: "right" },
        },
        {
          headerName: "미개선",
          field: "nonImprovement",
          flex: 1,
          cellStyle: { textAlign: "right" },
        },
        {
          headerName: "개선률",
          field: "improvementRate",
          flex: 1,
          cellStyle: { textAlign: "right" },
        },
      ],
      //
      manageGuiDetailData: [], // 신규 그리드를 위한 데이터
      manageGuiDetailDefs: [
        // 신규 그리드를 위한 컬럼 정의
        {
          headerName: "순서",
          valueGetter: "node.rowIndex",
          width: 34,
          cellStyle: (params) => {
            if (params.node.rowIndex === 0) {
              return { display: "none" }; // 특정 행에서만 숨김
            }
            return { textAlign: "center" };
          },
        },
        {
          headerName: "점번",
          field: "VAN_BIZ_NO",
          flex: 0.8,
          cellStyle: { textAlign: "center" },
          colSpan: (params) => {
            // 조건에 따라 열 병합
            if (params.data.VAN_BIZ_NO === "합계") {
              return 2; // 두 개의 열을 병합
            }
            return 1; // 기본적으로 한 개의 열
          },
        },
        {
          headerName: "점명",
          field: "SHOP_NM",
          flex: 1.2,
          cellStyle: (params) => {
            if (params.data.branchNm === "합계") {
              return { display: "none" }; // 특정 행에서만 숨김
            }
            return { textAlign: "center" };
          },
        },
        {
          headerName: "전월 누적",
          field: "LASTPROFIT",
          flex: 1,
          cellStyle: (params) => {
            let style = {};
            style.textAlign = "right";
            if (params.value < 0) {
              style.color = "blue"; // 음수일 때 파란색
            } else {
              style.color = "red"; // 양수일 때 빨간색
            }
            return style;
          },
        },
        {
          headerName: "당월 수익",
          field: "PROFIT",
          flex: 1,
          cellStyle: (params) => {
            let style = {};
            style.textAlign = "right";
            if (params.value < 0) {
              style.color = "blue"; // 음수일 때 파란색
            } else {
              style.color = "red"; // 양수일 때 빨간색
            }
            return style;
          },
        },
        {
          headerName: "사업보증금\n적립금 합계",
          valueGetter: (params) => {
            return params.data.LASTPROFIT + params.data.PROFIT;
          },
          flex: 1.2,
          cellStyle: (params) => {
            let style = {};
            style.textAlign = "right";
            if (params.value < 0) {
              style.color = "blue"; // 음수일 때 파란색
            } else {
              style.color = "red"; // 양수일 때 빨간색
            }
            return style;
          },
        },
      ],
      manageGuidanceGridOptions: {
        defaultColDef: {
          resizable: true,
          sortable: true,
          headerStyle: {
            backgroundColor: "#87a9e9",
            color: "black",
            textAlign: "center",
            alignContent: "center",
          },
        },
        headerHeight: 25,
        rowHeight: 22.5,
        rowSelection: { mode: "singleRow", checkboxes: false },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },
      managerGuiDetailGridOptions: {
        defaultColDef: {
          resizable: true,
          sortable: true,
          headerStyle: {
            backgroundColor: "#d2ffe8",
            color: "black",
            textAlign: "center",
            alignContent: "center",
          },
        },
        headerHeight: 35,
        rowHeight: 22.5,
        rowSelection: { mode: "singleRow", checkboxes: false },
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
      },
      branchColors: {
        "00": "#c8fdd1",
        "01": "#7dabd0",
        "02": "#cfe7ea",
        "03": "#fbc1ad",
        "04": "#40cdea",
        "05": "#f7d970",
        "06": "#b4e2c4",
        "07": "#ead6bf",
        "08": "#d6bbe1",
        "09": "#fcd9dd",
        "10": "#ffcaf8",
        "11": "#FAF3E1",
      },
      getRowHeight: (params) => {
        if (params.node.rowPinned && params.data.height) {
          return params.data.height;
        }
        return 18;
      },
    };
  },
  watch: {
    useNewGrid: {
      handler(newVal) {
        this.showNewGrid = newVal;

        if (newVal && this.manageGuidanceData.length === 0) {
          this.loadManageGuidanceData();
        }
      },
      immediate: true,
    },
  },

  created() {
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
      if (this.userInfo.OGN_FG !== "00") {
        alert("접근 권한이 없습니다.");
        this.$router.push("/PrListPage"); // 매장 사용자의 기본 페이지로 리디렉션
      }
    } else {
      // 로그인 정보가 없으면 로그인 페이지로 리디렉션
      this.$router.push("/");
    }
  },

  async mounted() {
    if (this.userInfo && this.userInfo.OGN_FG === "00") {
      window.addEventListener("resize", this.handleResize);
      if (['김정규', '김종배', '이재진', '육상용', '김춘규'].includes(this.userInfo.EMP_NM)||
        ["관리자팀"].includes(this.userInfo.EMP_DEPT_NM)||['본부장'].includes(this.userInfo.EMP_CLASS_NM)) {
        try {
          const getMonthCode = (date) => {
            const y = date.getFullYear();
            const m = (date.getMonth() + 1).toString().padStart(2, "0");
            return `${y}${m}`;
          };

          const now = new Date();
          const hour = now.getHours();
          const nextMonthCode = getMonthCode(now); // 이번달
          const prevMonthCode = getMonthCode(
            new Date(now.getFullYear(), now.getMonth() - 1, 1),
          ); // 전월
          const prevYearCode = getMonthCode(
            new Date(now.getFullYear() - 1, now.getMonth(), 1),
          ); // 전년

          const params = {
            prevMonth: prevMonthCode,
            prevYear: prevYearCode,
            nextMonth: nextMonthCode,
          };

          if (this.userInfo.EMP_CLASS_NM === '본부장') {
            params.branchCd = this.userInfo.BRANCH_CD
          }

          if (hour >= 10 && hour < 12) {
            // API 호출
            const res = await axios.get("/api/bmListPage/downtrend", { params } );
            // SQL 실행 API
            if (res.data && res.data.length > 0) {
              this.downShops = res.data;
              this.showDownPopup = true; // 팝업 띄우기
            }
          }
        } catch (err) {
          console.error("하락 점포 조회 실패:", err);
        }
      }
      try {
        // 1. 데이터 준비(Priming) API를 먼저 호출하여 동시성 문제를 방지합니다.
        await this.primeData();

        // 2. 데이터 준비가 완료된 후, 나머지 데이터들을 병렬로 빠르게 조회합니다.
        await Promise.all([
          this.loadMainTable(),
          this.loadYearBest(),
          this.loadBranchBest(),
        ]);
      } catch (error) {
        console.error("데이터 로딩 중 오류 발생:", error);
        // 사용자에게 오류 메시지를 표시하는 로직을 추가할 수 있습니다.
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    // sortedShops() {
    //   if (!this.sortKey) return this.downShops;
    //   return [...this.downShops].sort((a, b) => {
    //     const valA = a[this.sortKey] || 0;
    //     const valB = b[this.sortKey] || 0;
    //     return (valA - valB) * this.sortOrder;
    //   });
    // },
  },
  methods: {
    async primeData() {
      // 이 API는 SP를 한번만 호출하여 일일 데이터를 준비하는 역할을 합니다.
      await axios.get("/api/bmListPage/primeData");
    },
    async loadMainTable() {
      // 실제 API로 대체
      const res = await axios.get("/api/bmListPage/mainTable");
      this.mainTableData = res.data;
    },
    async loadYearBest() {
      // 실제 API로 대체
      const res = await axios.get("/api/bmListPage/yearBest");

      this.yearBestData = res.data;
    },
    async loadBranchBest() {
      // 실제 API로 대체
      const res = await axios.get("/api/bmListPage/branchBest");

      this.branchBestData = res.data;
    },
    async loadManageGuidanceData() {
      // 실제 API 호출
      const res = await axios.get("/api/bmListPage/manageGuidance");

      this.manageGuidanceData = res.data;
    },
    // toggleNewGridView() {
    //   this.showNewGrid = !this.showNewGrid;
    //   // 신규 그리드를 보여줄 때 데이터가 없으면 로드합니다.
    //   if (this.showNewGrid && this.manageGuidanceData.length === 0) {
    //     this.loadManageGuidanceData();
    //   }
    // },
    getMainCellStyle(params) {
      const year = params.data?.years;
      const branchCd = params.data?.branchCd;
      const value = params.value;
      const field = params.colDef.field;

      // '3년평균' 행 스타일
      if (year === "3년평균") {
        if (branchCd && this.branchColors[branchCd]) {
          return { background: this.branchColors[branchCd] };
        }
      }
      // '차이' 행 스타일
      if (year === "차이") {
        const style = { background: "yellow" };
        // 값이 숫자인 경우에만 색상 스타일 적용
        if (typeof value === "number") {
          if (value > 0) {
            style.color = "red"; // 양수일 때 빨간색
          } else if (value < 0) {
            style.color = "blue"; // 음수일 때 파란색
          }
        }
        return style;
      }

      // 월별 데이터 (m01 ~ m12) 스타일
      if (
        branchCd &&
        branchCd !== "00" &&
        field &&
        field.startsWith("m")
        // field !== "mSum"
      ) {
        if (value > 100) {
          return { color: "red" };
        } else if (value <= 100 && value > 0) {
          return { color: "blue" };
        }
      }

      return {}; // 기본 스타일
    },
    getMainGridStyle(params) {
      const branchCd = params.data?.branchCd;
      const style = {};
      // 본부명 셀 스타일
      // branchCd에 따른 배경색 적용
      if (branchCd && this.branchColors[branchCd]) {
        style.background = this.branchColors[branchCd];
      }
      if (
        params.colDef.field === "branchNm" ||
        params.colDef.field === "years"
      ) {
        style.textAlign = "center"; // 본부명과 연도 셀은 가운데 정렬
        style.alignContent = "center";
        style.whiteSpace = "pre-line"; // 줄바꿈 허용
      }
      return style;
    },
    handleResize() {
      const isWide = window.innerWidth > 1024;
      const newRowHeight = isWide ? 22 : 18;
      const newGridHeight1 = isWide ? 50 : 43.75;
      const newGridHeight2 = isWide ? 25 : 21.875;
      const newGridHeight3 = isWide ? 19 : 17.75;
      const newGridHeight4 = isWide ? 31 : 26;
      if (this.rowHeight !== newRowHeight) {
        this.rowHeight = newRowHeight;
        if (this.gridApi) this.gridApi.resetRowHeights();
      }
      if (
        this.gridHeight2 !== newGridHeight2 &&
        this.gridHeight1 !== newGridHeight1 &&
        this.gridHeight3 !== newGridHeight3 &&
        this.gridHeight4 !== newGridHeight4
      ) {
        this.gridHeight1 = newGridHeight1;
        this.gridHeight2 = newGridHeight2;
        this.gridHeight3 = newGridHeight3;
        this.gridHeight4 = newGridHeight4;
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
    },
    onCellClicked(event) {
      if (event.node) {
        event.node.setSelected(true); // 행(row)을 선택
        if (event.rowIndex !== 0 || event.node.data.branchCd !== "00") {
          if (
            event.colDef.field === "target" ||
            event.colDef.field === "improvement" ||
            event.colDef.field === "nonImprovement"
          ) {
            // 클릭한 셀의 field에 따라 index 결정
            let index;
            switch (event.colDef.field) {
              case "target":
                index = 1;
                break;
              case "improvement":
                index = 2;
                break;
              case "nonImprovement":
                index = 3;
                break;
              default:
                index = 0; // 또는 다른 기본값
            }
            this.fetchDetailData(event.node.data.BRANCH_CD, index);
          } else {
            this.manageGuiDetailData = []; // 다른 셀 클릭 시 상세 데이터 초기화
          }
        }
      }
    },
    async fetchDetailData(branchCd, index) {
      const res = await axios.get(
        `/api/bmListPage/detailData?branchCd=${branchCd}&index=${index}`,
      );
      this.manageGuiDetailData = res.data; // 하단 그리드에 바인딩할 데이터
    },

    calculateRowSpan(params) {
      if (!params.data || !params.data.branchNm) return 1;
      const branchNm = params.data.branchNm;
      const rowIndex = params.node.rowIndex;

      // 이전 행과 값이 같으면 1 반환 (병합된 셀의 일부로 처리됨)
      if (rowIndex > 0) {
        const prevNode = params.api.getDisplayedRowAtIndex(rowIndex - 1);
        if (prevNode && prevNode.data && prevNode.data.branchNm === branchNm) {
          return 1;
        }
      }
      // 이후 행들과 값이 같은지 확인하여 병합할 행 수 계산
      let count = 1;
      let nextIndex = rowIndex + 1;
      let nextNode = params.api.getDisplayedRowAtIndex(nextIndex);

      while (nextNode && nextNode.data && nextNode.data.branchNm === branchNm) {
        count++;
        nextIndex++;
        nextNode = params.api.getDisplayedRowAtIndex(nextIndex);
      }
      return count;
    },

    // sortBy(key) {
    //   if (this.sortKey === key) {
    //     // 같은 컬럼을 다시 클릭하면 오름/내림차순 토글
    //     this.sortOrder *= -1;
    //   } else {
    //     this.sortKey = key;
    //     this.sortOrder = 1;
    //   }
    // },

    onSortChanged(params) {
      // 정렬 후 실행할 로직
      let i = 1;
      params.api.forEachNode((node) => {
        if (!node.rowPinned) {
          node.data.No = i++;
        }
      });
      // No 컬럼 갱신
      params.api.refreshCells({ columns: ['no'] });
    },
  },
};
</script>

<style scoped>
.bm-list-page {
  display: flex;
  flex-direction: row;
  /* gap: 16px; */
  padding: 3px;
}
.main-table-section {
  flex: 2;
  width: 70%;
}
.side-table-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 30%;
  /* gap: 16px; */
}
.side-table-group {
  display: flex;
  flex-direction: column;
  /* gap: 16px; */
}
.side-table {
  background: #f8f8f8;
  /* padding: 12px; */
  padding-left: 3px;
  padding-right: 3px;
}

:deep(.ag-bm-balham) {
  --ag-cell-horizontal-padding: 2px; /* 셀 내부 좌우 패딩 */
  --ag-cell-vertical-padding: 1px; /* 셀 내부 상하 패딩 */
}

:deep(.ag-bm-balham .ag-header-cell-comp-wrapper) {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* grid 헤더 텍스트 정렬 */
:deep(.ag-bm-balham .ag-header-cell-label) {
  justify-content: center !important;
  white-space: pre-line;
}

/* grid 데이터 셀 스타일 */
:deep(.ag-bm-balham .ag-cell) {
  font-size: 0.72rem;
  text-align: right;
  /* padding-right: 3px; */
}

/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  :deep(.ag-bm-balham .ag-cell) {
    font-size: 1rem;
  }
  :deep(.ag-bm-balham .ag-header-cell-text) {
    font-size: 0.85rem;
  }
}

.popup {
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border: 2px solid #444;
  border-radius: 8px;
  padding: 20px;
  width: 800px;
  max-height: 70vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;
}

.popup h3 {
  margin-top: 0;
  font-size: 20px;
  color: #d9534f; /* 붉은색 강조 */
}

.popup-header {
  display: flex;
  justify-content: space-between; /* 제목 왼쪽, 버튼 오른쪽 */
  align-items: center;
}

.popup p {
  margin: 10px 0;
  font-size: 14px;
  color: #333;
}

.popup table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.popup th,
.popup td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
  font-size: 13px;
}

.popup th {
  background-color: #f5f5f5;
  font-weight: bold;
}

.popup tr:nth-child(even) {
  background-color: #fafafa;
}

.popup button {
  margin-top: 15px;
  padding: 8px 16px;
  background-color: #d9534f;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.popup button:hover {
  background-color: #c9302c;
}
</style>
